import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { LoadingBlock } from "@/components/AsyncState";

const SquadDetailPage = lazy(() => import("@/pages/SquadDetailPage"));

function SquadDetailFallback() {
  return (
    <div
      className="relative overflow-hidden bg-background"
      style={{ height: "100dvh", display: "flex", flexDirection: "column" }}
    >
      <div className="pointer-events-none absolute inset-x-0 top-0 h-56 bg-gradient-glow" />
      <div className="relative shrink-0 px-5 pt-14 pb-2">
        <h1 className="text-lg font-bold text-foreground">Squad</h1>
      </div>
      <div className="relative flex-1 px-5">
        <LoadingBlock label="Squad wird geladen…" />
      </div>
    </div>
  );
}

function SquadDetailRoute() {
  return (
    <Suspense fallback={<SquadDetailFallback />}>
      <SquadDetailPage />
    </Suspense>
  );
}

export const Route = createFileRoute("/squad/$id")({
  component: SquadDetailRoute,
});
